import type { SVGProps } from "react";
export function Music(props: SVGProps<SVGSVGElement>) {
  return (
    <svg
      fill="none"
      height={16}
      viewBox="0 0 16 16"
      width={16}
      xmlns="http://www.w3.org/2000/svg"
      data-slot="icon"
      {...props}
    >
      <path
        clipRule="evenodd"
        d="m13.2358 2.32198c-.0001.00003.0001-.00002 0 0l-6.21494 1.6992c-.488.16536-.80956.61451-.80949 1.11256v.57982l7.47963-2.30144v-.75854c-.0001-.10455-.0497-.20566-.1383-.27204-.0891-.06672-.2067-.08947-.3169-.05956zm1.4308 1.43937v-1.108c-.0002-.41535-.1976-.80443-.5292-1.05277-.3312-.24795-.7592-.32853-1.158-.2199l-6.22879 1.70296c-.00793.00217-.0158.00454-.02367.00712-.88659.29141-1.49127 1.11175-1.49117 2.04304 0-.00002 0 .00002 0 0v1.22886c-.00018.00745-.00018.01494 0 .02242v3.30218c-.39935-.34146-.90044-.54901-1.4634-.54901-1.41486 0-2.439 1.31085-2.439 2.76425s1.02414 2.7642 2.439 2.7642c1.23916 0 2.17861-1.0055 2.39283-2.2316.02962-.063.04617-.1333.04617-.2074v-5.49342l7.47963-2.30141v3.24177c-.4076-.30615-.9144-.48761-1.4634-.48761-1.3471 0-2.43903 1.09197-2.43903 2.43903 0 1.34704 1.09193 2.43904 2.43903 2.43904 1.284 0 2.3363-.9922 2.4319-2.25179.0047-.02706.0071-.0549.0071-.08325v-5.9463c.0002-.00745.0002-.01492 0-.02241zm-.9756 5.86471c0-.8082-.6553-1.46342-1.4634-1.46342-.8082 0-1.4634.65522-1.4634 1.46342 0 .80824.6552 1.46344 1.4634 1.46344.8081 0 1.4634-.6552 1.4634-1.46344zm-8.45523 2.27644c0-1.0611-.72302-1.7886-1.4634-1.7886-.74037 0-1.4634.7275-1.4634 1.7886s.72303 1.7886 1.4634 1.7886c.74038 0 1.4634-.7275 1.4634-1.7886z"
        fill="currentColor"
        fillRule="evenodd"
      />
    </svg>
  );
}
